import React from 'react';

const HostedCheckoutAbout = () => {
  return (
    <div className="about-content">
      <h3>Documentation</h3>
      <ul>
        <li>
          <a href="https://docs.stripe.com/checkout/quickstart" target="_blank" rel="noopener noreferrer">
            Quickstart
          </a>
        </li>
      </ul>
    </div>
  );
};

export default HostedCheckoutAbout;
